import { UseFormReturn } from 'react-hook-form';
import { observer } from 'mobx-react-lite';
import { EventPanelFormType } from '@mark43/cad-api';
import { LoadingIndicator } from '../common/components/loading-indicator';
import { useUpdateDispositionOrClearEventContent } from '../fr-event-common-components/fr-disposition/hooks/use-update-disposition-or-clear-event-content';
import { FrClearEventContainer } from './components/fr-clear-event-container';
import { FrClearOrUnassignPageContent } from './components/fr-clear-or-unassign-page-content';
import { useIntegratedForm } from '../forms/use-integrated-form';

export const FrClearEventPage = observer(function FrClearEventPage() {
    const {
        eventId,
        unitId,
        isPrimaryUnit,
        dispositionOptions,
        agencyId,
        agencyTypeGlobalAttrId,
        cautions,
        areCautionsLoading,
        eventLocation,
        eventForm,
    } = useUpdateDispositionOrClearEventContent();
    const { query: eventQuery } = useIntegratedForm();

    if (eventQuery.isFetching) {
        return <LoadingIndicator />;
    }

    return (
        <FrClearEventContainer>
            <FrClearOrUnassignPageContent
                isClearEventPage
                saveMutationErrorMsg="clearing event"
                eventId={eventId}
                unitId={unitId}
                isPrimaryUnit={isPrimaryUnit}
                dispositionOptions={dispositionOptions}
                agencyId={agencyId}
                agencyTypeGlobalAttrId={agencyTypeGlobalAttrId}
                cautions={cautions}
                areCautionsLoading={areCautionsLoading}
                eventLocation={eventLocation}
                eventForm={(eventForm as unknown) as UseFormReturn<EventPanelFormType>}
            />
        </FrClearEventContainer>
    );
});
